import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

import { LinkTargetEnum } from '@app-graphql/schema'
import { PlpBannerLike } from '@app-lib/plp-banner.lib'

@Component({
    selector: 'app-plp-banner-card',
    templateUrl: './plp-banner-card.component.html',
    styleUrls: ['./plp-banner-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PlpBannerCardComponent {

    @Input()
    public plpBanner: PlpBannerLike

    public get linkTarget(): string {
        const target = this.plpBanner.link?.target ?? LinkTargetEnum.Self

        return `_${ target.toLowerCase() }`
    }

}
